import { render, staticRenderFns } from "./Endorsement.vue?vue&type=template&id=d9b438a6&scoped=true"
import script from "./Endorsement.vue?vue&type=script&lang=ts"
export * from "./Endorsement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b438a6",
  null
  
)

export default component.exports